import { ROUTE_PARAMS } from '../route-params';

/**
 * Users controller route constants
 *
 * Maps to @Controller('users')
 *
 */
export const USERS_ROUTES = {
  // Standard REST routes
  ROOT: '',
  GET_BY_ID: ROUTE_PARAMS.ID,
  EFFECTIVE_PERMISSIONS: `${ROUTE_PARAMS.ID}/effective-permissions`,
  ASSIGN_ROLES: `${ROUTE_PARAMS.ID}/assign-roles`,
  ASSIGN_DESIGNATIONS: `${ROUTE_PARAMS.ID}/assign-designations`,

} as const;

/**
 * Type representing all possible user routes
 */
export type UsersRoute = (typeof USERS_ROUTES)[keyof typeof USERS_ROUTES];
